import React from 'react'

const CheckIcon = props => (
    <svg {...props} className='check_icon' width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.15021 3.98005C0.940001 3.77631 0.940001 3.42703 1.15021 3.22329C1.39045 3.01955 1.72078 3.01955 1.93099 3.22329L4.45351 5.6682L10.0691 0.196264C10.2793 -0.00747852 10.6397 -0.00747852 10.8499 0.196264C11.0601 0.429112 11.0601 0.749278 10.8499 0.953021L4.84391 6.77423C4.63369 7.00707 4.27333 7.00707 4.06312 6.77423L1.15021 3.98005Z" fill="white"/>
    </svg>

)

export default CheckIcon